import { LocalDate } from '../../../models';

export interface ShipmentWaybillNotificationsModel {
  receivedDateTime: LocalDate;
  reference: string;
  reasonCode: string;
  reasonCodeText: string;
  freeText: string;
}
